<template>
  <div class="cb-header__wrap cb-transition__slide" id="cb-header-wrap" ref="parent" role="banner">
    <cb-slide-n-fade>
      <div class="cb-header__logo cb-transition__slide" v-if="showLogo">
        <img class="cb-header__image" :src="logo" :alt="organisation_name || site_name">
      </div>
    </cb-slide-n-fade>
    <cb-slide-n-fade>
      <h1 class="cb-header__title cb-transition__slide" id="cb-header-title" :style="themeColor" ref="x" :class="{'cb-header__title--xl':!(this.$route.meta.showCheckoutSteps && checkout_steps.length > 1) && !(this.$route.meta.headerLogo && logo)}" v-if="this.$route.meta.isHeaderTitle || !(this.$route.meta.headerLogo && logo)">
        {{header}}
      </h1>
    </cb-slide-n-fade>
    <cb-slide-n-fade>
      <div class="cb-header__wizard cb-transition__slide" id="cb-header-wizard" v-if="this.$route.meta.showCheckoutSteps && checkout_steps.length > 1">
        <div class="cb-header__button" :class="{'cb-header__button--active' : current_checkout_step == i}" :style="backgroundColor" v-for="i in checkout_steps" v-bind:key="i" :aria-current="current_checkout_step == i ? 'step' : false" ></div>
      </div>
    </cb-slide-n-fade>
  </div>
</template>
<script type="text/javascript">
import {
  mapGetters
} from "vuex"
export default {
  mounted() {
      this.editMode = this.$route.query.mode == "edit";
    },
    data() {
      return {
        editMode: false
      }
    },
    computed: {
      ...mapGetters([
        "checkout_steps",
        "current_checkout_step",
        "organisation_name",
        "site_name",
      ]),
      showLogo() {
        return (this.$route.meta.headerLogo || this.$store.getters.skip_cart) && this.logo;
      },
      header() {
        if (this.$route.meta.commonTranslate) {
          return this.$store.getters.common_translate(this.$route.meta.headerTitle);
        }
        if (this.$route.meta.headerTitle) {
          return this.$store.getters.translate(this.$route.meta.headerTitle);
        }
        return this.$store.getters.translate(this.editMode ? `${this.$route.name}.header.edit` : `${this.$route.name}.header`);
      },
    },
}
</script>
